<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="报名页名称列表" name="1">
      <KyltTitleAdd :updataID='updataID'></KyltTitleAdd>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * lx
 * 报名页名称修改
 */
import KyltTitleAdd from '../../../../static/form/KyltTitleAdd.vue'
export default {
  components: {
    KyltTitleAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/KyltMgl'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/KyltTitleUpdate.vue